export enum FORTUNE_WHEEL_PRIZE_ID {
  POINT1 = 'point1',
  POINT2 = 'point2',
  POINT3 = 'point3',
  POINT4 = 'point4',
  SPIN1 = 'spin1',
  SPIN3 = 'spin3',
  SPIN5 = 'spin5',
  SPIN10 = 'spin10',
  USDT5 = 'usdt5',
  USDT10 = 'usdt10',
  USDT50 = 'usdt50',
  USDT100 = 'usdt100',
  USDT500 = 'usdt500',
  DROPEE1 = 'dropee1',
  DROPEE5 = 'dropee5',
  DROPEE10 = 'dropee10',
  DROPEE50 = 'dropee50',
  DROPEE100 = 'dropee100',
  DROPEE500 = 'dropee500',
  STARS5 = 'stars5',
  STARS10 = 'stars10',

  GOLD_FEATHER_10 = 'gold_feather_10',
  IDEA_10 = 'idea_10',
  SPIN_GOLDEN1 = 'spin_golden1',
  TICKET = 'ticket',
  // Gotcha cards
  GACHA_BOX_CARD1 = 'gacha_box_card1',
  GACHA_BOX_CARD2 = 'gacha_box_card2',
  GACHA_BOX_CARD3 = 'gacha_box_card3',
  GACHA_BOX_CARD4 = 'gacha_box_card4',
  GACHA_BOX_CARD5 = 'gacha_box_card5',
  // Prize box items
  PRIZE_BOX_DOUBLE_PROFIT_10_MINS = 'prize_box_double_profit_10_mins',
  PRIZE_BOX_DOUBLE_PROFIT_20_MINS = 'prize_box_double_profit_20_mins',
  PRIZE_BOX_OFFLINE_PROFIT_10_MINS = 'prize_box_offline_profit_10_mins',
  PRIZE_BOX_OFFLINE_PROFIT_20_MINS = 'prize_box_offline_profit_20_mins',
  PRIZE_BOX_GOLDEN_COIN_1 = 'prize_box_golden_coin_1',
  PRIZE_BOX_GOLDEN_COIN_3 = 'prize_box_golden_coin_3',
  PRIZE_BOX_SPIN_3 = 'prize_box_spin_3',
  PRIZE_BOX_SPIN_5 = 'prize_box_spin_5',
  PRIZE_BOX_SPIN_10 = 'prize_box_spin_10',
  PRIZE_BOX_TICKET_1 = 'prize_box_ticket_1',
  PRIZE_BOX_GOLD_FEATHER_50 = 'prize_box_golden_feather_50',
  PRIZE_BOX_GOLD_FEATHER_100 = 'prize_box_golden_feather_100',
  PRIZE_BOX_IDEA_50 = 'prize_box_idea_50',

  // Golden only
  GOLDEN_USDT25 = 'golden_usdt25',
  GOLDEN_USDT50 = 'golden_usdt50',
  GOLDEN_USDT100 = 'golden_usdt100',
  GOLDEN_USDT500 = 'golden_usdt500',
  GOLDEN_USDT1000 = 'golden_usdt1000',
  GOLDEN_USDT2000 = 'golden_usdt2000',
  GOLDEN_USDT5000 = 'golden_usdt5000',
  GOLDEN_DROPEE25 = 'golden_dropee25',
  GOLDEN_DROPEE50 = 'golden_dropee50',
  GOLDEN_DROPEE100 = 'golden_dropee100',
  GOLDEN_DROPEE500 = 'golden_dropee500',
  GOLDEN_DROPEE1000 = 'golden_dropee1000',
  GOLDEN_DROPEE2000 = 'golden_dropee2000',
  GOLDEN_DROPEE5000 = 'golden_dropee5000',
  GOLDEN_SPIN5 = 'golden_spin5',
  GOLDEN_SPIN10 = 'golden_spin10',
  GOLDEN_SPIN25 = 'golden_spin25',
  GOLDEN_SPIN50 = 'golden_spin50',
  GOLDEN_COIN_1 = 'golden_coin_1',
  GOLDEN_COIN_2 = 'golden_coin_2',
  GOLDEN_STARS10 = 'golden_stars10',
  GOLDEN_STARS25 = 'golden_stars25',
  GOLDEN_STARS50 = 'golden_stars50',
  GOLDEN_STARS100 = 'golden_stars100',

  HORSE_SPIRIT_3 = 'horse_spirit_3',
  FIRECRACKER_20 = 'firecracker_20',
}

export enum FORTUNE_WHEEL_PRIZE_TYPE {
  SPIN = 'spin',
  SPIN_GOLDEN = 'spin_golden',
  POINTS = 'points',
  FREE_UPGRADE = 'free_upgrade',
  USDT = 'usdt',
  DROPEE = 'dropee',
  TICKET = 'ticket',
  GACHA_BOX_ITEM = 'gacha_box_item',
  PRIZE_BOX_ITEM = 'prize_box_item',
  GOLD_FEATHER = 'gold_feather',
  IDEA = 'idea',
  GOLDEN_COIN = 'golden_coin',
  STAR = 'star',
  HORSE_SPIRIT = 'horse_spirit',
  FIRECRACKER = 'firecracker',
}

export enum FORTUNE_WHEEL_PRIZE_SUBTYPE {
  DOUBLE_PROFIT = 'double_profit',
  OFFLINE_PROFIT = 'offline_profit',
  GOLDEN_COIN = 'golden_coin',
  SPIN = 'spin',
  TICKET = 'ticket',
  GOLD_FEATHER = 'goldFeather',
  IDEA = 'idea',
}

export type FortuneWheelPrize = {
  id: FORTUNE_WHEEL_PRIZE_ID
  type: FORTUNE_WHEEL_PRIZE_TYPE
  subtype?: FORTUNE_WHEEL_PRIZE_SUBTYPE
  amount: number
}

export type FortuneWheelPrizeV2 = {
  id: string
  currency: string
  amount: number
}

// Predefined currencies with special wheel rendering logic
export enum WHEEL_CURRENCY {
  SPIN = 'spin',
  STAR = 'star',
  GOLDEN_COIN = 'goldenCoin',
  DROPEE = 'dropee',
  GIVEAWAY_TICKET = 'giveawayTicket',
  POINTS = 'points',
}

export type FortuneWheelSlice = {
  prizeId: string
  currency: string
  amount: number
  isShining: boolean
  replaceWithGiveawayTicket: boolean
  color: string
}

export type PlayerFortuneWheelState = {
  lastWonPrizes: FORTUNE_WHEEL_PRIZE_ID[],
  usdtCentsBalance: number
  usdtCentsBalanceAllTime: number
  dropeeCentsBalance: number
  dropeeCentsBalanceAllTime: number
  cards: Record<string, { count: number, lastAcquisitionTimestamp: number }>
  totalCentsSpent?: number
  spins: {
    total: number
    available: number
    lastDailyTicketTimestamp: number
    lastSpinDate: string
    streak: number
    maxStreak: number
  },
  withdrawals: {
    timestamp: number,
    amount: number,
    status: string,
    convertedAmount: number,
    convertedTo: 'spin' | 'usdt' | 'star'
  }[]
}
